import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'eoc-on-call.title',
		defaultMessage: 'On Call - Operations',
		description: 'This text will be displayed in the document title',
	},
});
